module.exports = __webpack_public_path__ + "static/media/doisirmaos.ad4bbb98.webp";